import { PriceItem } from '@/features/common/components/Overview/types'
import Button from '@/features/openTabs/components/AccountActionButton'
import CollapsibleFooter from '@/features/openTabs/components/CollapsibleFooter'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface AccountFooterProps {
    totalPrice: string
    priceItems: PriceItem[]
    canSplit: boolean
    canPay: boolean
    onAddOrder: () => void
    onSplit?: () => void
    onPayAll: () => void
}

const AccountFooter: FC<AccountFooterProps> = ({
    totalPrice,
    priceItems,
    canSplit,
    canPay,
    onAddOrder,
    onSplit,
    onPayAll,
}) => {
    const { t } = useTranslation('app')
    const { styles } = useStyles(stylesheet)

    return (
        <CollapsibleFooter
            totalPrice={totalPrice}
            priceItems={priceItems}
            testID="open-account-footer"
        >
            <Button
                type="outline"
                color="primary"
                FrontIcon={PlusIcon}
                onPress={onAddOrder}
                style={styles.fullWidthButton}
            >
                {t('openTabs.actions.addOrder')}
            </Button>
            <View style={styles.actions}>
                <Button
                    disabled={!canSplit}
                    color="secondary"
                    onPress={onSplit}
                    style={styles.button}
                >
                    {t('openTabs.actions.split')}
                </Button>
                <Button disabled={!canPay} color="action" onPress={onPayAll} style={styles.button}>
                    {t('openTabs.actions.payAll')}
                </Button>
            </View>
        </CollapsibleFooter>
    )
}

const stylesheet = createStyleSheet({
    actions: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
    },
    fullWidthButton: {
        width: '100%',
        height: 44,
        justifyContent: 'center',
        borderRadius: 8,
    },
    button: {
        flex: 1,
        height: 44,
        justifyContent: 'center',
        borderRadius: 8,
    },
})

export default AccountFooter
